export const darkTheme = {
  themePrimary: '#fd6262',
  themeLighterAlt: '#0a0404',
  themeLighter: '#281010',
  themeLight: '#4c1e1e',
  themeTertiary: '#973b3b',
  themeSecondary: '#de5757',
  themeDarkAlt: '#fd7272',
  themeDark: '#fd8888',
  themeDarker: '#ffe4e4',
  neutralLighterAlt: '#1b1a19',
  neutralLighter: '#2A2A2A',
  neutralLight: '#1a1918',
  neutralQuaternaryAlt: '#181716',
  neutralQuaternary: '#171615',
  neutralTertiaryAlt: '#161514',
  neutralTertiary: '#c8c8c8',
  neutralSecondary: '#d0d0d0',
  neutralPrimaryAlt: '#dadada',
  neutralPrimary: '#ffffff',
  neutralDark: '#f4f4f4',
  black: '#f8f8f8',
  white: '#202020',
} as const;

